angular.module('app')
    .controller('aggiornamentoDocCtrl', function (
        $scope,
        RiUserF
    ) {
        var init = function () {

        }

        init();
    })